import { z } from 'zod';
import { terraContract } from '@terra/shared-authorization';
import {
  GetK8sOperatorSqsCredentialsResponseSchema,
  HeartbeatK8sOperatorBodySchema,
  HeartbeatK8sOperatorResponseSchema,
  InitializeK8sOperatorBodySchema,
  InitializeK8sOperatorResponseSchema,
  K8sOperatorInfoResponseSchema,
  UpdateK8sOperatorExecutionOutputChunkBodySchema,
  UpdateK8sOperatorExecutionOutputChunkResponseSchema,
  UpdateK8sOperatorExecutionOutputFinalBodySchema,
  UpdateK8sOperatorExecutionOutputFinalResponseSchema,
  UpdateK8sOperatorExecutionStatusBodySchema,
  UpdateK8sOperatorExecutionStatusResponseSchema,
} from './cockpit.schemas';

export const cockpitPublicRoutes = {
  initializeK8sOperator: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/initialize',
      summary: 'Initialize K8S operator from full CRD payload',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: InitializeK8sOperatorBodySchema }))
    .output(InitializeK8sOperatorResponseSchema),
  heartbeatK8sOperator: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/heartbeat',
      summary: 'Record K8S operator heartbeat from access token',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: HeartbeatK8sOperatorBodySchema }))
    .output(HeartbeatK8sOperatorResponseSchema),
  getK8sOperatorSqsCredentials: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/sqs-credentials',
      summary: 'Get temporary SQS credentials for K8S operator polling',
      inputStructure: 'detailed',
    })
    .output(GetK8sOperatorSqsCredentialsResponseSchema),
  getK8sOperatorInfo: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'GET',
      path: '/k8s-operators/info',
      summary: 'Get K8S operator info from access token',
      inputStructure: 'detailed',
    })
    .output(K8sOperatorInfoResponseSchema),
  updateK8sOperatorExecutionStatus: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/executions/status',
      summary: 'Update K8S operator execution status from access token',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: UpdateK8sOperatorExecutionStatusBodySchema }))
    .output(UpdateK8sOperatorExecutionStatusResponseSchema),
  updateK8sOperatorExecutionOutputChunk: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/executions/output/chunk',
      summary: 'Append K8S operator execution output chunk',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: UpdateK8sOperatorExecutionOutputChunkBodySchema }))
    .output(UpdateK8sOperatorExecutionOutputChunkResponseSchema),
  updateK8sOperatorExecutionOutputFinal: terraContract
    .meta({
      permissions: ['K8S Operators Client'],
    })
    .route({
      method: 'POST',
      path: '/k8s-operators/executions/output/final',
      summary: 'Set K8S operator execution final output',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: UpdateK8sOperatorExecutionOutputFinalBodySchema }))
    .output(UpdateK8sOperatorExecutionOutputFinalResponseSchema),
};

export const cockpitPublicContract = terraContract.router(cockpitPublicRoutes);
